/*
 * Copyright (c) 2018-2021 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import AccountIcon from '@mui/icons-material/AccountCircle';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useGetUserQuery } from 'store/api/version-api.slice';

import ChangePasswordDialog from './ChangePasswordDialog';
import { styles } from './styles';
import UpdateContactInfoDialog from './UpdateContactInfoDialog';

const Profile = () => {
	const [userDialogOpen, setUserDialogOpen] = useState(false);
	const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);

	const { data: profile = {} } = useGetUserQuery();

	const toggleDialog = () => setUserDialogOpen(prev => !prev);
	const togglePassDialog = () => setPasswordDialogOpen(prev => !prev);

	return (
		<Box display="flex">
			<AccountIcon sx={styles.icon} />
			<Box display="flex" flexDirection="column" flexGrow={1} padding="8px">
				<Box display="flex">
					<Typography component={'span'} paddingRight="8px" variant="h6">
						{profile.first_name}
					</Typography>
					<Typography component={'span'} variant="h6">
						{profile.last_name}
					</Typography>
				</Box>
				<Typography component={'span'} variant="h6">
					{profile.email}
				</Typography>
				<Box sx={styles.spacer}></Box>
				<Button
					fullWidth
					variant={'outlined'}
					sx={{ ...styles.BtnUpdate, marginBottom: '8px' }}
					onClick={toggleDialog}
				>
					update contact info
				</Button>
				<Button fullWidth variant={'outlined'} sx={styles.BtnUpdate} onClick={togglePassDialog}>
					update password
				</Button>
			</Box>
			<UpdateContactInfoDialog toggleDialog={toggleDialog} isOpen={userDialogOpen} />
			<ChangePasswordDialog isOpen={passwordDialogOpen} togglePassDialog={togglePassDialog} />
		</Box>
	);
};

export default Profile;
